import {Component} from "../Component";
import {element} from "../CustomElement";
import {inject} from "../../services/di";
import {RatingObject} from "../../definitions/CommonDefinitions";

import {UserAgentService} from "../../services/UserAgentService";
import {AppRatingService} from "../../services/AppRatingService";

@element("flipp-app-rating")
export class AppRating extends Component<{}, any> {
	@inject userAgent: UserAgentService;
	@inject appRating: AppRatingService;

	formatReviews(reviews: number) {
		if (reviews <= 1000) {
			return `${reviews}`;
		} else if (reviews < 1000000) {
			return `${(reviews / 1000).toFixed(0)}k`;
		} else {
			return `${(reviews / 1000000).toFixed(1)}M`;
		}
	}

	calculateRating(ratingObj: RatingObject) {
		const {appStore, playMarket} = ratingObj;
		const appReviews = this.userAgent.iOS ? appStore : playMarket;
		const {rating, reviews} = appReviews;
		const starsArray = [];
		for (let i = 0; i < Math.ceil(rating); i++) {
			starsArray.push("https://f.wishabi.net/creative/Distribution/images/icons/rating-star.svg");
		}
		return <div class="stars-wrapper">
			{starsArray.map(star => <img src={star} alt="star"/>)}
			<div class="reviews">{this.formatReviews(reviews)}</div>
		</div>;
	}

	render() {
		const ratings = this.appRating.getAppRating();
		return <div class="rating-wrapper">{this.calculateRating(ratings)}</div>;
	}
}
